exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#login{padding-top:20px}#login .wrap{max-width:300px}#login .wrap label{display:block;position:relative;height:60px;margin-bottom:20px;width:100%}#login .wrap label i{position:absolute;left:10px;top:13px;color:#ccc;font-size:3.4rem}#login .wrap label input{width:100%;height:60px;padding-left:70px;font-size:1.8rem;border:1px solid #ccc;color:#999}#login .wrap label input:focus{color:#5698d2;border-color:#5698d2}#login .wrap label input:focus+i{color:#5698d2}#login .wrap label+label{margin-bottom:25px}#login .wrap label+input{height:60px;width:100%;margin:auto;margin-bottom:50px;font-size:1.8rem;font-weight:700;letter-spacing:.3rem;display:block}#login a{display:block;text-align:center;font-size:1.4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77bd8072","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/Login.vue
// module id = 642
// module chunks = 0